import React from "react";
import { Outlet } from "react-router-dom";

function Coupen() {
  return <Outlet />;
}

export default Coupen;
